/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsSendSubscriptionForm204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsSendSubscriptionForm505Schema = z.any();

export const optionsSendSubscriptionFormMutationResponseSchema = z.lazy(() => optionsSendSubscriptionForm204Schema);
